module.exports = __webpack_public_path__ + "img/devzapp.9f696a8c.png";